export const apiErr = (err, fallback = 'Operation failed') =>
  err?.data?.details?.join(', ') ||
  err?.data?.error               ||
  err?.data?.message             ||
  err?.message                   ||
  fallback;

// Backend stock precheck (see docs/features/stock-availability-precheck) replies
// 422 with details: { code: "insufficient_stock", product_id, available, requested }
// instead of an array — surface it distinctly from the array-shaped validation details.
export const insufficientStockMessage = (err) => {
  const details = err?.data?.details;
  if (!details || details.code !== 'insufficient_stock') return null;
  return err.data.error || `Only ${details.available} available — ${details.requested} requested`;
};
